import React from 'react';
import { Form2 } from '../primitives/Forms2';
import { CRMMenu } from './Elements/CRMMenu';
import { FormGrid, LoadingIndicator, OccupyFreeSpace, SaveButton, TabPanel, TabsHeader, useSaveable, useTabsState } from '../primitives';
import { useCRMSettingsEdit } from './data/useCRMSettingsEdit';
import { ContactAttributesConfigurationEditor } from './Elements/Settings/ContactAttributesConfigurationEditor';
import { ContactCategoriesConfigurationEditor } from './Elements/Settings/ContactCategoriesConfigurationEditor';

interface Props {
  
}

export const SettingsPage = (props: Props) => {
  const tabs = useTabsState([
    ["contact_attributes","Категории и атрибуты контактов"],
  ]);

  const data = useCRMSettingsEdit();

  useSaveable({ hasChanges: !!data.hasChanges, save: data.save });

  return (<>
    <Form2
      noTitle
      background="panel"
      fitFullHeight

      headerItems={<>
        <CRMMenu title="Настройки" current="settings" />

       
        <OccupyFreeSpace />

        {false && <LoadingIndicator sizeVariant="s" />}
        {data.hasChanges && <SaveButton action={() => data.save()} />}

        
      </>}
      subHeaderItems={<>
        
      </>}
    >
      <TabsHeader state={tabs} noMargin />

      <TabPanel state={tabs.forTab("contact_attributes")}>
        <FormGrid columns="1fr 3fr" forceEvenColumns>

          <ContactCategoriesConfigurationEditor
            item={data.item}
            update={data.update}
            />

          <ContactAttributesConfigurationEditor
            item={data.item}
            update={data.update}
            />
        </FormGrid>
      </TabPanel>
    </Form2>

  </>);
}
